import React from "react";
import type { SubscriptionAlertItem } from "./types";

const levelStyles: Record<
  SubscriptionAlertItem["level"],
  { bar: string; badge: string }
> = {
  INFO: {
    bar: "border-blue-500/60 bg-blue-500/5",
    badge: "bg-blue-500/15 text-blue-200 ring-blue-500/30",
  },
  WARNING: {
    bar: "border-amber-500/60 bg-amber-500/5",
    badge: "bg-amber-500/15 text-amber-100 ring-amber-500/30",
  },
  CRITICAL: {
    bar: "border-red-500/60 bg-red-500/5",
    badge: "bg-red-500/15 text-red-100 ring-red-500/30",
  },
};

export function SubscriptionAlertsPanel(props: {
  items: SubscriptionAlertItem[];
}): React.JSX.Element {
  const { items } = props;

  return (
    <section className="rounded-2xl border border-slate-800 bg-slate-900/40 p-4 shadow-lg backdrop-blur-sm md:p-5">
      <div className="border-b border-slate-800 pb-3">
        <h2 className="text-sm font-semibold text-white">Points à corriger</h2>
        <p className="text-xs text-slate-500">
          Synthèse métier à partir des données chargées (clients + contrats).
        </p>
      </div>

      {/* Grille : 3 colonnes en lg → 6 alertes sur 2 rangées ; 2 colonnes en md */}
      <ul className="mt-4 grid grid-cols-1 gap-3 md:grid-cols-2 lg:grid-cols-3">
        {items.map((a) => {
          const st = levelStyles[a.level];
          return (
            <li
              key={a.id}
              className={`flex flex-col justify-center gap-1 rounded-xl border px-3 py-2.5 ${st.bar}`}
            >
              {/* Ligne 1 : niveau + libellé + nombre */}
              <div className="flex min-w-0 items-baseline gap-2">
                <span
                  className={`shrink-0 rounded-full px-1.5 py-0.5 text-[9px] font-bold uppercase tracking-wide ring-1 ${st.badge}`}
                >
                  {a.level}
                </span>
                <span className="min-w-0 flex-1 truncate text-xs font-medium leading-snug text-slate-100">
                  {a.label}
                </span>
                <span className="shrink-0 tabular-nums text-base font-bold leading-none text-white">
                  {a.count}
                </span>
              </div>
              {/* Ligne 2 : action */}
              <p className="line-clamp-2 text-[11px] leading-snug text-slate-400">{a.action}</p>
            </li>
          );
        })}
      </ul>
    </section>
  );
}
